module.exports = __webpack_public_path__ + "img/Image-4.134b7086.png";